import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useAction } from './Contexts/CharacterActions.js';
import stylesFor from './traitSelectStyles.js';

const TraitSelector = ({
  SelectedTrait,
  Traits,
  ignoreUsedTraits,
  setStyle,
  baseColor,
  onSelectionChanged,
}) => {
  const { mapTraitToOption } = useAction();
  const CustomSingleValue = ({ data }) => (
    <div>{setStyle === 'compact' ? data.shortLabel : data.label}</div>
  );
  const [, setPrevTraits] = useState();
  const [options, setOptions] = useState([]);
  const [selectedTrait, setSelectedTrait] = useState();

  const customStyles = stylesFor(setStyle, baseColor);

  useEffect(() => {
    setPrevTraits(Traits);
    const newOptions = Traits.map(item =>
      mapTraitToOption({ item, ignoreUsed: ignoreUsedTraits })
    );
    setOptions(newOptions);
    var selectedName = SelectedTrait.name;
    setSelectedTrait(
      selectedName ? newOptions.find(opt => opt.name === selectedName) : ''
    );
  }, [Traits, mapTraitToOption, SelectedTrait, ignoreUsedTraits]);

  return (
    <div>
      <Select
        styles={customStyles}
        options={options}
        menuPosition="absolute"
        menuPortalTarget={document.body}
        isSearchable={false}
        value={selectedTrait}
        components={{ SingleValue: CustomSingleValue }}
        onChange={onSelectionChanged}
      />
    </div>
  );
};
export default TraitSelector;
